import {GET_SUMMARY_DETAILS } from "../../utils/constants"


const initialState = [];

function summaryReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_SUMMARY_DETAILS:
            return [...state, payload];
        default:
            return state;
    }
};

export default summaryReducer;